import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import {baseUrl} from "../Univ";
function OpDep() {
    const [consData, setConsData] = useState([]);
    useEffect(() => {
        axios.get(baseUrl + "cons-search/")
            .then(res => setConsData(res.data))
            .catch(console.error);
    }, []);
    const departments = [...new Map(consData.map(c => [c.department, c])).values()];
    const departmentConfig = {
        "CARDIOLOGY": {
            icon: "fa-solid fa-heart-pulse", color: "#DC2626", subtitle: "Heart & Vascular"
        }, "ORTHOPAEDICS": {
            icon: "fa-solid fa-bone", color: "#2563EB", subtitle: "Bones & Joints"
        }, "PSYCHIATRIS": {
            icon: "fa-solid fa-brain", color: "#7C3AED", subtitle: "Mental Health"
        }, "DERMATOLOGY": {
            icon: "fa-solid fa-hand-sparkles", color: "#EC4899", subtitle: "Skin Care"
        }, "GASTROENTRO SURGERY": {
            icon: "fa-solid fa-prescription-bottle-medical", color: "#F97316", subtitle: "Digestive Surgery"
        }, "UROLOGY": {
            icon: "fa-solid fa-droplet", color: "#0891B2", subtitle: "Kidney & Urinary Care"
        }, "GENERAL SURGERY": {
            icon: "fa-solid fa-user-doctor", color: "#0F766E", subtitle: "General Surgical Care"
        }, "ENT": {
            icon: "fa-solid fa-ear-listen", color: "#06B6D4", subtitle: "Ear • Nose • Throat"
        }, "PLASTIC SURGERY": {
            icon: "fa-solid fa-scissors", color: "#E11D48", subtitle: "Reconstructive Surgery"
        }, "PULMONOLOGY": {
            icon: "fa-solid fa-lungs", color: "#059669", subtitle: "Lung Care"
        }, "PEDIATRIC UROLOGY": {
            icon: "fa-solid fa-baby", color: "#0EA5E9", subtitle: "Children's Urology"
        }, "NEUROLOGY": {
            icon: "fa-solid fa-brain", color: "#8B5CF6", subtitle: "Brain & Nerves"
        }, "GYNAEC & OBSTETRIC": {
            icon: "fa-solid fa-person-pregnant", color: "#DB2777", subtitle: "Women's Health"
        }, "NEPHROLOGY": {
            icon: "fa-solid fa-kidneys", color: "#2563EB", subtitle: "Kidney Medicine"
        }, "PAEDIATRIC": {
            icon: "fa-solid fa-baby", color: "#F59E0B", subtitle: "Children Care"
        }, "ANESTHETIC": {
            icon: "fa-solid fa-syringe", color: "#6366F1", subtitle: "Anaesthesia"
        }, "GENERAL MEDICINE": {
            icon: "fa-solid fa-stethoscope", color: "#16A34A", subtitle: "Primary Care"
        }, "DENTAL": {
            icon: "fa-solid fa-tooth", color: "#EA580C", subtitle: "Dental Care"
        }, default: {
            icon: "fa-solid fa-hospital", color: "#2563EB", subtitle: "Hospital Department"
        }
    };
    return (<section className="container mt-4">

        <div className="text-center mb-5">

            <h2 className="op-title">
                <i className="fa-solid fa-stethoscope me-2"></i>
                OP Appointment
            </h2>

        </div>

        <div className="row g-4">

            {departments.map((item) => {
                const config = departmentConfig[item.department] || departmentConfig.default;
                return (<div
                    className="col-xl-3 col-lg-4 col-md-6"
                    key={item.department}
                >

                    <Link
                        to={`/op-appointment/${item.department}`}
                        className="text-decoration-none"
                    >

                        <div className="menu-card department-card">

                            <div className="department-icon">

                                <i
                                    className={config.icon}
                                    style={{
                                        color: config.color, fontSize: config.fontSize || "50px"
                                    }}
                                ></i>
                            </div>

                            <h5 className="department-title">

                                {item.department}

                            </h5>


                        </div>

                    </Link>

                </div>);
            })}

        </div>

    </section>);
}
export default OpDep;